import PageView from './PageView';
import './Page.css';

export default PageView;
